export default __webpack_public_path__ + "static/media/bb.4ad0112b.svg";